import { Plus, Trash2, ArrowUp, ArrowDown, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const blank = { station_id: "", minutes: "", distance_km: "" };

function StopRow({ s, i, n, options, update, move, remove }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid={`route-stop-${i}`}>
      <div className="mb-2 flex items-center gap-2">
        <span className="grid h-6 w-6 place-items-center rounded-full bg-[#0052FF] text-xs font-bold text-white">{i + 1}</span>
        <div className="min-w-0 flex-1">
          <Select value={s.station_id || ""} onValueChange={(v) => update(i, "station_id", v)}>
            <SelectTrigger className="h-9 bg-white" data-testid={`route-stop-station-${i}`}><SelectValue placeholder="Select stop station" /></SelectTrigger>
            <SelectContent>{options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <Button type="button" size="icon" variant="ghost" className="h-8 w-8" disabled={i === 0} onClick={() => move(i, -1)} data-testid={`route-stop-up-${i}`}><ArrowUp className="h-4 w-4" /></Button>
        <Button type="button" size="icon" variant="ghost" className="h-8 w-8" disabled={i === n - 1} onClick={() => move(i, 1)} data-testid={`route-stop-down-${i}`}><ArrowDown className="h-4 w-4" /></Button>
        <Button type="button" size="icon" variant="ghost" className="h-8 w-8" onClick={() => remove(i)} data-testid={`route-stop-remove-${i}`}><Trash2 className="h-4 w-4 text-rose-500" /></Button>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {[["minutes", "Minutes after departure"], ["distance_km", "Km from start"]].map(([k, l]) => (
          <label key={k} className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">{l}
            <Input type="number" min={0} value={s[k] ?? ""} onChange={(e) => update(i, k, e.target.value)} className="mt-1 h-9 bg-white" data-testid={`route-stop-${k}-${i}`} />
          </label>
        ))}
      </div>
    </div>
  );
}

export default function StopsEditor({ value, onChange, options, form }) {
  const list = value || [];
  const set = (l) => onChange(l);
  const update = (i, k, v) => set(list.map((s, j) => (j === i ? { ...s, [k]: v } : s)));
  const move = (i, d) => { const l = [...list]; [l[i], l[i + d]] = [l[i + d], l[i]]; set(l); };
  const remove = (i) => set(list.filter((_, j) => j !== i));
  const used = [form.origin_id, form.destination_id];
  const opts = (s) => options.filter((o) => !used.includes(o.value) && (o.value === s.station_id || !list.some((x) => x.station_id === o.value)));
  return (
    <div className="space-y-2" data-testid="route-stops-editor">
      <p className="text-xs text-slate-500">Add the mid stop points in travel order. Fares for every combination are set in the fare table below.</p>
      {list.map((s, i) => <StopRow key={i} s={s} i={i} n={list.length} options={opts(s)} update={update} move={move} remove={remove} />)}
      {!list.length && <div className="flex items-center gap-2 rounded-xl border border-dashed border-slate-300 p-3 text-xs text-slate-500"><MapPin className="h-4 w-4" />Non-stop route - no stops in between.</div>}
      <Button type="button" variant="outline" size="sm" className="rounded-full" onClick={() => set([...list, { ...blank }])} data-testid="route-add-stop-button"><Plus className="h-4 w-4" />Add stop</Button>
    </div>
  );
}
